import type { DeviceV2 } from "../types";

export function findDeviceIdByType(
  devices: DeviceV2[] | undefined,
  deviceType: string,
): string | null {
  if (!devices?.length) return null;
  const match = devices.find(
    (device) => String(device?.deviceType ?? device?.type ?? "") === deviceType,
  );
  return match?._id ? String(match._id) : null;
}
